export default __webpack_public_path__ + "static/media/bar-coldchain.9bac98c9.svg";